/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable guard-for-in */
/* eslint-disable no-console */
import SelectorEngine from '../../../utils/dom/selector-engine';
import { Events } from '../../../utils/dom/html-events';
import EventHandler from '../../../utils/dom/event-handler';
import Modal from '../../../components/Modal';
import { ClassNames } from '../../../utils/dom/css-classes';
import Request, { ApiMode } from '../../../utils/request';
import FormGenerator, { FormTypes } from '../../../components/FormGenerator';
import { startLoadingAnimation, stopLoadingAnimation } from '../../../utils/dom/loading';

const SELECTOR_WRAPPER = '.p-coaches-self-declaration';
const SELECTOR_MODAL = '.js-coaches-self-declaration-modal';

const SELECTOR_SPLASH = '.p-coaches-self-declaration-splash';
const SELECTOR_SPLASH_NEXT = '.p-coaches-self-declaration-splash-next';

const SELECTOR_STEP = '.p-coaches-self-declaration-step';
const SELECTOR_QUESTION = '.p-coaches-self-declaration-questions';

const SELECTOR_EXIT_BUTTON = '.js-exit-coaches-self-declaration';
const SELECTOR_EXIT_CONFIRM_MODAL = '.js-exit-coaches-self-declaration-confirm';
const SELECTOR_EXIT_CONFIRM_YES = '.js-exit-coaches-self-declaration-confirm-yes';
const SELECTOR_EXIT_CONFIRM_NO = '.js-exit-coaches-self-declaration-confirm-no';

const SELECTOR_CONFIRMATION_CONFIRM_BUTTON = '.p-coaches-self-declaration-confirmation-confirm';

const SELECTOR_SUCCESS = '.p-coaches-self-declaration__success';
const SELECTOR_SUCCESS_FOR_NO = '.p-coaches-self-declaration__success-for-selecting-no';
const SELECTOR_SUCCESS_FOR_YES = '.p-coaches-self-declaration__success-for-selecting-yes';
const SELECTOR_SUCCESS_BUTTON = '.p-coaches-self-declaration__success-btn';

const SELECTOR_ERROR = '.lta-coaches-self-declaration-error-container';

const IS_LOCAL = false;

const CLICK_EVENT = 'click';
const HIDDEN_CLASS = 'u-hidden';
const FLEX_CLASS = 'u-flex';

const KEY_OBJECT = 'fieldName';
const VALUE_OBJECT = 'value';

class SelfDeclaration {
	constructor() {
		this._wrapper = SelectorEngine.findOne(SELECTOR_WRAPPER);
		if (!this._wrapper) {
			return;
		}
		this.init();
	}

	get stepsData() {
		return this._stepsData;
	}

	set stepsData(_stepsData) {
		this._stepsData = _stepsData;
		if (_stepsData?.length > 0) {
			this.initiateFormGenerator(_stepsData);
		}
	}

	init() {
		this.modalElement = SelectorEngine.findOne(SELECTOR_MODAL, this._wrapper);
		this.modal = new Modal(this.modalElement, { backdrop: 'static' });
		this.modal.show();

		this.splash = SelectorEngine.findOne(SELECTOR_SPLASH, this._wrapper);
		this.splashNext = SelectorEngine.findOne(SELECTOR_SPLASH_NEXT, this.splash);

		this.step = SelectorEngine.findOne(SELECTOR_STEP, this._wrapper);
		this.questions = SelectorEngine.findOne(SELECTOR_QUESTION, this.step);

		this.exitButton = SelectorEngine.findOne(SELECTOR_EXIT_BUTTON, this._wrapper);
		const exitConfirmModalHtml = SelectorEngine.findOne(SELECTOR_EXIT_CONFIRM_MODAL, this._wrapper);
		this.exitConfirmModal = new Modal(exitConfirmModalHtml, { backdrop: 'static' });

		this.exitConfirmYes = SelectorEngine.findOne(SELECTOR_EXIT_CONFIRM_YES, this._wrapper);
		this.exitConfirmNo = SelectorEngine.findOne(SELECTOR_EXIT_CONFIRM_NO, this._wrapper);

		this.selfDeclarationSuccess = SelectorEngine.findOne(SELECTOR_SUCCESS, this._wrapper);
		this.selfDeclarationSuccessButton = SelectorEngine.findOne(SELECTOR_SUCCESS_BUTTON, this.selfDeclarationSuccess);

		this.selfDeclarationSuccessForNo = SelectorEngine.findOne(SELECTOR_SUCCESS_FOR_NO, this.selfDeclarationSuccess);
		this.selfDeclarationSuccessForYes = SelectorEngine.findOne(SELECTOR_SUCCESS_FOR_YES, this.selfDeclarationSuccess);

		this._errorContainer = SelectorEngine.findOne(SELECTOR_ERROR, this._wrapper);
		this._errorText = SelectorEngine.findOne('.error-text', this._errorContainer);
		this._closeErrorSnackBar = SelectorEngine.findOne('.js-dismiss-error', this._errorContainer);

		this._closeErrorSnackBar.addEventListener('click', () => {
			this._errorContainer.classList.add('u-hidden');
			window.location.reload();
		});

		this.selfDeclarationModal = new Modal(this.modalElement, { backdrop: 'static' });
		this.selfDeclarationModal.isEscapeEventEnable = false;

		this.selfDeclarationModal.show();

		this.SelfDeclarationConfirmButton = SelectorEngine.findOne(SELECTOR_CONFIRMATION_CONFIRM_BUTTON, this._wrapper);

		EventHandler.on(this.SelfDeclarationConfirmButton, CLICK_EVENT, () => {
			this.SelfDeclarationConfirmButton.disabled = true;
			this.saveSelfDeclarationSteps(this.answerList);
		});

		EventHandler.on(this.coachesSelfDeclarationSuccessButton, CLICK_EVENT, () => {
			this.coachesSelfDeclarationModal.hide();
		});
		this.initEventHandlers();
	}

	initEventHandlers() {
		EventHandler.on(this.splashNext, Events.Click, () => {
			this.fetchSteps();
		});
		EventHandler.on(this.exitButton, Events.Click, () => {
			this.exitConfirmModal.show();
		});
		EventHandler.on(this.exitConfirmYes, Events.Click, () => {
			this.handleModalExit();
		});
		EventHandler.on(this.exitConfirmNo, Events.Click, () => {
			this.exitConfirmModal.hide();
		});
	}

	async fetchSteps() {
		startLoadingAnimation();
		try {
			const url = '/api/coachdetails/getcoachselfdeclarationform';
			const response = await Request.get(
				url,
				{},
				{
					local: IS_LOCAL,
					req: {
						apiMode: ApiMode.LtaError
					}
				}
			);
			const { Steps, error } = response;
			stopLoadingAnimation();
			if (Steps) {
				this.stepsData = Steps;
			}

			if (!!error?.hasError) {
				throw error;
			}
		} catch (error) {
			startLoadingAnimation();
			console.log('error', error);

			if (error.hasError) {
				console.log('Error :', error);
			}
		}
	}

	initiateFormGenerator(stepsData) {
		this.splash.classList.add(ClassNames.Hidden);
		this.step.classList.remove(ClassNames.Hidden);

		this.formGenerator = new FormGenerator(this.questions, {
			questions: stepsData,
			totalSteps: 2,
			hasSeparator: false,
			formType: FormTypes.StepForm,
			themeColor: 'color-lta-blue',
			radioAnswerField: 'id',
			isBackButtonEnabled: true,
			submitButton : {
				title: 'Submit'
			},
			backButtonHandlerFirstStep: () => {
				this.splash.classList.remove(ClassNames.Hidden);
				this.step.classList.add(ClassNames.Hidden);
			}
		});

		this.formGenerator.onChange((answers) => {
			this.step.classList.add(HIDDEN_CLASS);
			this.prepareRequestObject(answers);
			this.saveSelfDeclarationSteps(this.answerList);
		});
	}

	prepareRequestObject(stepsAnswers) {
		this.answerList = {};
		for (const stepKey in stepsAnswers) {
			const stepAnswersObjects = stepsAnswers[stepKey];
			for (const questionKey in stepAnswersObjects) {
				const answerObject = stepAnswersObjects[questionKey];
				const formatObject = {};
				formatObject[answerObject[KEY_OBJECT]] = answerObject[VALUE_OBJECT];
				this.answerList = {
					...this.answerList,
					...formatObject
				};
			}
		}
	}

	showSuccessPage(token) {
		this.step.classList.add(HIDDEN_CLASS);
		this.selfDeclarationSuccess.classList.remove(HIDDEN_CLASS);
		if (token === 'true') {
			this.selfDeclarationSuccessForNo.classList.add(HIDDEN_CLASS);
			this.selfDeclarationSuccessForYes.classList.remove(HIDDEN_CLASS);
		} else {
			this.selfDeclarationSuccessForNo.classList.remove(HIDDEN_CLASS);
			this.selfDeclarationSuccessForYes.classList.add(HIDDEN_CLASS);
		}
	}

	showErrorContainer(message) {
		this.step.classList.remove(HIDDEN_CLASS);
		this._errorContainer.classList.add(FLEX_CLASS);
		this._errorContainer.classList.remove(HIDDEN_CLASS);
		this._errorText.innerHTML = message;
	}

	async saveSelfDeclarationSteps(requestObject) {
		startLoadingAnimation();
		try {
			const url = '/api/coachdetails/UpdateCoachSelfDeclarationDetails';
			const response = await Request.post(url, requestObject, {
				local: IS_LOCAL,
				req: {
					apiMode: ApiMode.LtaError
				}
			});
			const { Success, success, error, message } = response;
			stopLoadingAnimation();
			if ((Success || success) === true) {
				if (requestObject.finalWarningFlag === 'yes' || requestObject.policeInvestigationFlag === 'yes') {
					this.showSuccessPage('true');
				} else {
					this.showSuccessPage('false');
				}
			} else {
				this.showErrorContainer(message);
			}
		} catch (error) {
			stopLoadingAnimation();
			this.showErrorContainer(message);
		}
	}

	handleModalExit() {
		// Go back to the page that launched the modal
		history.back();
	}
}

const globalSelfDeclaration = new SelfDeclaration();
export default globalSelfDeclaration;
